import { render, staticRenderFns } from "./CompanionIcon.vue?vue&type=template&id=4bd7c398&scoped=true&"
import script from "./CompanionIcon.vue?vue&type=script&lang=ts&"
export * from "./CompanionIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CompanionIcon.vue?vue&type=style&index=0&id=4bd7c398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7c398",
  null
  
)

export default component.exports